import React from "react";

// Files Import
import "./SocialIcons.css";
import { Link } from "react-router-dom";
import { content } from "../../../data";

const SocialIcons = () => {
  return (
    <ul className="">
      <li className="flex brightness  gap-4 justify-between">
        {content.socialIconImages.map((items, index) => (
          <Link
            to={items.link}
            key={index}
            className=" facebook relative flex items-center justify-center text-white p-4 "
            href="#"
          >
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <img src={items.icon} alt="icon missing" width={40} loading="lazy"/>
          </Link>
        ))}
      </li>
    </ul>
  );
};

export default SocialIcons;
